const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

function twoUnits(big: number, bigUnit: string, small: number, smallUnit: string): string {
  return small > 0 ? `${big}${bigUnit} ${small}${smallUnit} ago` : `${big}${bigUnit} ago`;
}

/**
 * "just now", "5m ago", "3h 12m ago", "3d 4h ago", then a date ("7 Mar", or
 * "28 Aug 2025" in another year). Hours roll into days, so an old item never
 * reads "4906h ago". Returns "" for missing or invalid input.
 */
export function formatRelative(
  input: string | number | Date | null | undefined,
  now: number = Date.now(),
): string {
  if (input === null || input === undefined || input === "") return "";
  const then = input instanceof Date ? input.getTime() : new Date(input).getTime();
  if (Number.isNaN(then)) return "";

  const diff = now - then;
  if (diff < MINUTE) return "just now";
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)}m ago`;
  if (diff < DAY) return twoUnits(Math.floor(diff / HOUR), "h", Math.floor((diff % HOUR) / MINUTE), "m");
  if (diff < 30 * DAY) return twoUnits(Math.floor(diff / DAY), "d", Math.floor((diff % DAY) / HOUR), "h");

  const date = new Date(then);
  const sameYear = date.getFullYear() === new Date(now).getFullYear();
  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    ...(sameYear ? {} : { year: "numeric" }),
  });
}
